import { marketplaceListConfig } from "./marketplaceListConfig";

export { marketplaceListConfig } from "./marketplaceListConfig";
export { postersListConfig } from "./postersListConfig";
export { physicalEditionListConfig } from "./physicalEditionListConfig";

/**
 * Resolves how many items a marketplace list should render.
 * A page-specific config wins when it sets `maxItems`; otherwise the global
 * marketplaceListConfig default is used.
 */
export const resolveListMaxItems = (pageListConfig) =>
  pageListConfig?.maxItems ?? marketplaceListConfig.maxItems;
